// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pastQuestion":"_32FgJF","editIcon":"DcCnGu"};